// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PromotionDisplay_overlay__24qXl","container":"PromotionDisplay_container__1txJX","text":"PromotionDisplay_text__21Hae"};